import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/auth/layout.tsx")